import React from "react";
import cn from "classnames";
import {createUseStyles} from "react-jss";
import {externalUrl} from "~/utils";

export default function NavbarLogo({className, ...props}) {
  const classes = useStyles();

  return (
    <a href={externalUrl('/dashboard')} className={cn(classes.root, className)} {...props}>
      <span className={classes.title}>Workshop Butler</span>
      <img
        className={classes.img}
        src={require('public/logo.png').default}
        alt='WSB'
      />
    </a>
  )
}

const useStyles = createUseStyles({
  root: {
    display: 'block',
    width: 28,
    height: 28,
    userSelect: 'none',
  },

  img: {
    width: '100%',
    height: '100%',
    userSelect: 'none',
    userDrag: 'none',
  },

  title: {
    display: 'none',
  }
});


